import { render, staticRenderFns } from "./VeJwCjlxModal.vue?vue&type=template&id=21535e2c"
import script from "./VeJwCjlxModal.vue?vue&type=script&lang=js"
export * from "./VeJwCjlxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports